import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { SalatiStatusRequest } from '../api/salati/salatistatus/salatistatusrequest';
import { SalatiStatusResponse, SalatiStatusResponseDtoImpl } from '../api/salati/salatistatus/salatistatusresponse';
import { SalatiStatusBuilder } from '../dto/salatistatus/salatistatusbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';

export class SalatiStatusAPIProcessorImpl extends SixdeeCRBTAPIProcessor<SalatiStatusRequest, SalatiStatusResponse>
{
    private LOGGER: Logger = LogManager.getLogger(SalatiStatusAPIProcessorImpl.name);
    execute(request: SalatiStatusRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        this.LOGGER.log("onSuccess() invoked");
        try {
            
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {
                
                let response = new SalatiStatusResponseDtoImpl(APIFeatures.SALATI_STATUS, "Salati Status Success");
                
                response.setSalatiStatusDtos(new SalatiStatusBuilder(responseMapper.getResponseMap()).buildAll());

               this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SalatiStatusResponseDtoImpl(APIFeatures.SALATI_STATUS, "No Salati Status Data Available"));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SalatiStatusResponseDtoImpl(APIFeatures.SALATI_STATUS, "Internal Server Error"));
            }
        }
        catch (e) {
            this.getAPIFailure(new SalatiStatusResponseDtoImpl(APIFeatures.SALATI_STATUS, "Internal Server Error"));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new SalatiStatusResponseDtoImpl(APIFeatures.SALATI_STATUS, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/salatistatusapiprocessor.tsx